import "./polyfills";
import "@franchises/bootstrap-theme";
import Turbolinks from "turbolinks";
import "~retailer/styles/index.scss";

Turbolinks.start();
